// extracted by mini-css-extract-plugin
module.exports = {"ReplyButton":"pr_a bhs_vr bhs_iv bhs_wf bhs_i bhs_j bhs_q bhs_un bhs_en bhs_ri bhs_rj bhs_cx","ReplyButton__icon":"pr_b bhs_re"};